import {TypedShapeCommand} from '../commands.template';
import {IResourceJson} from '../../diagram-data/diagram-json-handler.service';
import {isComponent} from '../../diagram-render/helpers/shapes-detectors.util';
import {v4 as uuidv4} from 'uuid';

export class ResourceSetMainCommand extends TypedShapeCommand<IResourceJson> {
  protected services: any;
  private main: boolean;
  private skipRecalculation: boolean;
  private remove: boolean;

  id = uuidv4();

  constructor(data) {
    super(data);
    this.main = Boolean(this.object.main);
  }

  public execute() {
    super.execute();
    const model = this.services.registry.getGraph().getModel();
    const cell = model.getCell(this.object.activityMxKey);
    const cellJson = cell.getJson();
    const resource = cellJson.resources.find(
      res => Number(res.mxKey) === Number(this.object.mxKey)
    );
    const mainOnResource = cellJson.resources.find(res => res.main);
    const visiblePreviousMain = !!mainOnResource && !mainOnResource?.hidden;

    this.skipRecalculation =
      (resource?.hidden && !this.main) ||
      (resource?.hidden && !visiblePreviousMain) ||
      (!resource?.hidden && visiblePreviousMain && this.main);
    this.remove = this.main && !resource?.hidden && !visiblePreviousMain;
    model.beginUpdate();
    cell.skipUndo = true;

    if (!this.skipRecalculation) {
      this.services.resourceSvc.recalcActivitySize(cell, cell.getJson(), {
        remove: this.remove,
        deltaKey: !this.remove ? this.id : null
      });
    }

    this.services.diagramUpdateSvc.update({
      changeResource: {
        activityMxKey: this.object.activityMxKey,
        mxKey: this.object.mxKey,
        main: this.main
      }
    });
    model.endUpdate();

    if (isComponent(cell)) {
      cell.comp.instance.setupFromJson();
    }
  }

  public reverse() {
    super.reverse();
    const model = this.services.registry.getGraph().getModel();
    const cell = model.getCell(this.object.activityMxKey);

    model.beginUpdate();
    cell.skipUndo = true;

    if (!this.skipRecalculation) {
      this.services.resourceSvc.recalcActivitySize(cell, cell.getJson(), {
        remove: !this.remove,
        deltaKey: !this.remove ? this.id : null
      });
    }

    this.services.diagramUpdateSvc.update({
      changeResource: {
        activityMxKey: this.object.activityMxKey,
        mxKey: this.object.mxKey,
        main: !this.main
      }
    });
    model.endUpdate();

    if (isComponent(cell)) {
      cell.comp.instance.setupFromJson();
    }
  }
}
